import _ from "lodash";

export const getPayloadWithHyperLink = (payload) => {

  const result = _.cloneDeep(payload);
  for(const item of result) {
    item.surveyIdNewTabHyperLink = '/survey/' + item.surveyId;
  }

  return result;

}